export default __webpack_public_path__ + "static/media/detail_mobile_11_3.095d27eb.jpg";